<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <section class="has-text-centered">
        <b-icon type="is-warning" icon="alert-outline" class="icon-modal"></b-icon>
        <p class="is-size-5 has-text-weight-bold">
          {{ $t('addEditFournisseurSupport.avertissement.title') }}
        </p>
        <avertissement-msg-component
          :messages="msgAvertissements"
          :canClose="false"
          class="mgt-20px"
          avertissement/>
      </section>
      <div class="has-text-centered mgt-20px">
        <button
          @click="$parent.close()"
          class="button btn-modal-annuler is-cancel has-text-centered button-modal">
          {{ $t('general.button.return') }}
        </button>
        <button
          @click="$emit('continuer')"
          class="button is-warning has-text-centered button-modal">
          {{ $t('general.button.next') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import avertissementMsgComponent from '@/components/general/avertissementMsgComponent';

export default {
  props: {
    msgAvertissements: {
      type: Array,
      required: true,
    },
  },
  components: {
    avertissementMsgComponent,
  },
};
</script>
